import { z } from "zod";
import {
  ADDRESS,
  ADDRESS_1,
  ADDRESS_2,
  ALTERNATE_LOGIN_ID,
  CITY,
  CORRESPONDENCE_ADDRESS,
  EMAIL_ID_1,
  EMAIL_ID_2,
  FIRST_NAME,
  LANDLINE_NO,
  LAST_NAME,
  MOBILE_NO,
  PO_BOX,
  SHOW_CORRESPONDENCE_ADDRESS,
  STATE,
  USER_ID,
  USERNAME,
  ZIPCODE,
} from "./consts";

export const schema = z.object({
  [USER_ID]: z.string().optional(),
  [ALTERNATE_LOGIN_ID]: z.string().min(4, "Please enter Alternate Login ID."),
  [FIRST_NAME]: z.string().min(2, "Please enter First Name."),
  [LAST_NAME]: z.string().min(2, "Please enter Last Name."),
  [MOBILE_NO]: z.string().min(10, "Please enter Mobile Number."),
  [EMAIL_ID_1]: z
    .string()
    .min(1, "Please enter Contact Email.")
    .email("This is not a valid email."),
  [ADDRESS]: z.object({
    [ADDRESS_1]: z.string().min(1, "Please enter Address 1."),
    [ADDRESS_2]: z.string().optional(),
    [ZIPCODE]: z
      .string()
      .min(1, "Please enter Zipcode.")
      .regex(/^[0-9]{5}-[0-9]{4}$/, "Enter ZIP code in XXXXX-XXXX format."),
    [STATE]: z.string().min(1, "Please enter State."),
    [CITY]: z.string().min(1, "Please enter City."),
    [PO_BOX]: z.string().min(1, "Please enter P.O. Box."),
  }),
  [SHOW_CORRESPONDENCE_ADDRESS]: z.boolean(),
  [CORRESPONDENCE_ADDRESS]: z.object({
    [ADDRESS_1]: z.string().optional(),
    [ADDRESS_2]: z.string().optional(),
    [STATE]: z.string().optional(),
    [CITY]: z.string().optional(),
    [ZIPCODE]: z
      .string()
      .optional()
      .refine((value) => !value || /^[0-9]{5}-[0-9]{4}$/.test(value), {
        message: "Enter ZIP code in XXXXX-XXXX format.",
      }),
    [PO_BOX]: z.string().optional(),
  }),

  // Optional Fields
  [LANDLINE_NO]: z.string().optional(),
  [EMAIL_ID_2]: z
    .string()
    .email("This is not a valid email.")
    .optional()
    .or(z.literal("")),
  [USERNAME]: z.string().min(4, "Please enter User ID."),
}).superRefine((data, ctx) => {
  if (data[SHOW_CORRESPONDENCE_ADDRESS]) {
    const address = data[CORRESPONDENCE_ADDRESS] as any;

    const requiredFields = [
      ADDRESS_1,
      STATE,
      CITY,
      ZIPCODE,
      PO_BOX,
    ];

    requiredFields.forEach((field) => {
      if (!address?.[field]?.trim()) {
        ctx.addIssue({
          path: [CORRESPONDENCE_ADDRESS, field],
          code: z.ZodIssueCode.custom,
          message: `This field is required`,
        });
      }
    });
  }
});

export type formValues = z.infer<typeof schema>;
